<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-02-27 13:25:48
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div v-if="selectBankShow" class="comp-select-bank">
        <el-dialog
            :title="dialogTitle"
            class="prop info-tips"
            :visible.sync="dialogShow"
            :before-close="dialogClose"
            width="620px"
        >
            <div class="cards-container">
                <div
                    v-for="(item, index) in dialogBankArr"
                    :key="index"
                    class="card-item"
                    v-on:click="selectCurCard(item, index)"
                >
                    <img class="card-img" src="@/assets/img/bankcard-logo.png" alt="" />
                    <div class="bank-detail">
                        <div>
                            <div class="line-1">
                                {{
                                    (item.paycentername == "汇款"
                                        ? item.paycentername
                                        : $cache.getDict("110079", item.paycenterid)) +
                                    "-" +
                                    $cache.getDict("110080", item.bankcode).substr(-4, 4) +
                                    "(" +
                                    item.depositcard.slice(-4) +
                                    ")"
                                }}
                                <div style="width: 20px; margin-left: 10px">
                                    <i v-if="curIndex === index" class="el-icon-check"></i>
                                </div>
                            </div>
                            <div v-if="way == '1'" class="line-2">
                                可用余额：
                                <span class="margin-r-10">
                                    {{
                                        $util.fmtNum(
                                            isBuy ? item.xjbasset : item.usableremainshare
                                        )
                                    }}&nbsp;元
                                </span>
                                <el-button
                                    v-show="isBuy"
                                    type="text"
                                    plain
                                    v-on:click.prevent="toCurrencyCharge"
                                >
                                    充值
                                </el-button>
                            </div>
                            <div v-else class="line-2">
                                交易限额：
                                <span v-if="item.maxlimitsingle" class="margin-r-10">
                                    单笔{{ $util.fmtNum(item.maxlimitsingle) }}元
                                </span>
                                <span v-if="item.perdaymax">
                                    单日{{ $util.fmtNum(item.perdaymax) }}元
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="$util.getBusinessModule('0A3')" class="add-card-container">
                <div
                    class="add-card"
                    v-on:click.prevent="
                        $router.push({
                            name: 'addbank'
                        })
                    "
                >
                    <i class="el-icon-circle-plus"></i>
                    新增银行卡
                </div>
            </div>
            <div class="button-container">
                <div class="btn-confirm" v-on:click="dialogConfirmClose">确定</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "SelectBank",
    props: {
        dialogTitle: {
            type: String,
            default: "请选择扣款账户"
        },
        selectBankShow: {
            type: Boolean,
            default: false
        },
        way: {
            // 1代表现金宝渠道
            type: String,
            default: ""
        },
        isBuy: {
            type: Boolean,
            default: true
        },
        dialogBankLists: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return { dialogShow: true, curIndex: -1, lastIndex: -1, dialogBankArr: [] };
    },
    watch: {
        selectBankShow(val) {
            this.dialogShow = val;
            this.dialogBankArr = this.dialogBankLists;
        }
    },
    created() {
        this.dialogShow = this.selectBankShow;
    },
    methods: {
        dialogClose() {
            this.dialogShow = false;
            this.$emit("select-bank-close", false);
            this.curIndex = this.lastIndex;
        },
        dialogConfirmClose() {
            this.dialogShow = false;
            this.$emit("select-bank-close", false);
            this.lastIndex = this.curIndex;
            this.$emit("select-bank-info", this.dialogBankArr[this.curIndex]);
        },
        selectCurCard(item, index) {
            this.curIndex = index;
            this.selectBankInfo = this.dialogBankArr[index];
        },

        toCurrencyCharge() {
            this.$router.push({ name: "currencycharge" });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.comp-select-bank {
    .cards-container {
        height: 200px;
        overflow-y: auto;
        padding: 40px 40px 0;

        .card-item {
            display: flex;
            width: 100%;
            border-bottom: 1px solid var(--color-border-base);
            padding-bottom: 12px;
            margin-bottom: 12px;
            cursor: pointer;
            .card-img {
                // display: inline-block;
                width: 30px;
                height: 30px;
                margin-right: 10px;
                position: relative;
                top: 5px;
            }
            .bank-detail {
                flex: 1;
                display: flex;
                align-items: center;
                .line-1 {
                    display: flex;
                    margin-bottom: 6px;
                    font-family: Source Han Sans CN;
                    font-size: 18px;
                    font-weight: normal;
                    color: var(--color-text-primary);
                }
                .line-2 {
                    font-family: Source Han Sans CN;
                    font-size: 14px;
                    font-weight: normal;
                    color: var(--color-text-accent);

                    .el-button.is-plain:hover,
                    .el-button.is-plain:focus,
                    .el-button.is-disabled.is-plain {
                        background-color: transparent;
                        border-color: transparent;
                    }
                }
                .el-icon-check {
                    color: var(--color-primary);
                    font-size: 18px;
                    font-weight: bold;
                }
            }
        }
    }
    .add-card-container {
        margin: 0 40px 20px 40px;
        padding: 20px 0;
        border-bottom: 1px solid var(--color-border-base);
    }
    .add-card {
        margin-left: 40px;
        font-family: Source Han Sans CN;
        font-size: 16px;
        color: var(--color-primary);
        cursor: pointer;
        .el-icon-circle-plus {
            margin-right: 2px;
            font-size: 18px;
        }
    }
    .button-container {
        width: 100%;
        text-align: center;
        .btn-confirm {
            color: var(--color-text-white);
            background-color: var(--color-primary);
            width: 150px;
            margin: 30px auto 0;
            padding: 10px 0;
            text-align: center;
            font-size: 16px;
            cursor: pointer;
        }
        .cancel {
            color: var(--color-text-primary);
            background: var(--color-accent);
        }
    }
    .confirm-btn {
        display: flex;
    }
    .margin-r-10 {
        margin-right: 10px;
    }
}
</style>
